import React from 'react'
import { Link } from 'react-router-dom'

const PasswordReset = () => {
    return (
        <div className="flex justify-center">
            <div className="md:w-full p-7 bg-white border rounded auth-body">
                <form>
                    <ul className="grid gap-4 list-none li_animate">
                        <li className="col-span-12">
                            <label htmlFor='emailaddress' className="block text-base text-gray-700">Email address</label>
                            <input
                                type="email"
                                className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                                placeholder="name@gmail.com"
                                id='emailaddress'
                            />
                            <small className="text-gray-500">An email will be sent to the above address with a link to set your new password.</small>
                        </li>
                        <li className="col-span-12 my-4">
                            <Link
                                className="block w-full py-3 bg-primary-900 hover:bg-primary-800 text-white text-center rounded-lg uppercase transition"
                                to="/two-step"
                                title="" >
                                Submit
                            </Link>
                        </li>
                        <li className="col-span-12 text-center">
                            <span className="text-gray-500">
                                <Link className="text-primary-900 font-semibold" to="/signin">Back to Sign in</Link>
                            </span>
                        </li>
                    </ul>
                </form>
            </div>
        </div>

    )
}

export default PasswordReset